import React, { useEffect, useState } from 'react';
import { formatCurrency } from '../../utils/invoiceFormatters';
import invoiceService from '../../services/invoiceService';

const COLORS = [
  '#378ADD', '#1D9E75', '#7F77DD', '#EF9F27', '#D85A30',
  '#27A69A', '#8E44AD', '#E67E22',
];

const TopEnterprisesChart = ({ month, year, source = 'ECMS' }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!month || !year) return;
    setLoading(true);
    setError(false);
    invoiceService.getInvoices({ month, year, page: 0, size: 100, source })
      .then(res => {
        const invoices = res.data?.content || [];
        const sorted = [...invoices]
          .filter(inv => inv.totalAmount > 0)
          .sort((a, b) => b.totalAmount - a.totalAmount)
          .slice(0, 8);
        setData(sorted);
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [month, year, source]);

  if (loading) {
    return (
      <div className="space-y-3">
        {[...Array(5)].map((_, i) => (
          <div key={i} className="flex items-center gap-3">
            <div className="h-3 bg-gray-200 rounded animate-pulse w-28" />
            <div className="h-4 bg-gray-200 rounded animate-pulse flex-1" />
            <div className="h-3 bg-gray-200 rounded animate-pulse w-16" />
          </div>
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-8">
        <p className="text-sm text-gray-400">Failed to load data</p>
      </div>
    );
  }

  if (data.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-sm text-gray-400">No invoices found for this month</p>
      </div>
    );
  }

  const max = data[0]?.totalAmount || 1;

  return (
    <div className="space-y-3">
      {data.map((inv, i) => {
        const pct = ((inv.totalAmount / max) * 100).toFixed(1);
        return (
          <div key={inv.id} className="flex items-center gap-3">
            <div className="w-32 shrink-0">
              <p className="text-xs font-semibold text-gray-700 truncate" title={inv.enterpriseName}>
                {inv.enterpriseName || `Enterprise #${inv.enterpriseId}`}
              </p>
            </div>
            <div className="flex-1 bg-gray-100 rounded-full h-4 overflow-hidden">
              <div
                className="h-full rounded-full transition-all duration-500"
                style={{ width: `${pct}%`, backgroundColor: COLORS[i % COLORS.length], minWidth: '4px' }}
              />
            </div>
            <span className="text-xs font-semibold text-gray-700 w-20 text-right shrink-0">
              {formatCurrency(inv.totalAmount)}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default TopEnterprisesChart;
